import { isURL } from '@/utils/helpers';

export function fileToDataUrl(file: File) {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = error => reject(error);
    reader.readAsDataURL(file);
  });
}

export function getFileName(file: string | File, extension: boolean): string {
  const fileName = typeof file === 'string' ? file : file.name;

  let fileUrlName = fileName;

  if (isURL(fileUrlName)) {
    fileUrlName = decodeURIComponent(
      new URL(fileName).pathname.split('/').pop()!
    );
  }

  if (!fileUrlName) return fileName; // some default fileUrlName

  if (extension) return fileUrlName.split('.').pop()!;

  return fileUrlName;
}
